import * as API from '../api'

export const FETCHING_OVERVIEW = 'FETCHING_OVERVIEW'
export const FETCH_OVERVIEW = 'FETCH_OVERVIEW'
export const FETCH_OVERVIEW_ERROR = 'FETCH_OVERVIEW_ERROR'
export const TOGGLE_PRODUCTS_TABLE = 'TOGGLE_PRODUCTS_TABLE'

export const FETCHING_OVERVIEW_LIST = 'FETCHING_OVERVIEW_LIST'
export const FETCH_OVERVIEW_LIST = "FETCH_OVERVIEW_LIST"
export const FETCH_OVERVIEW_LIST_ERROR = "FETCH_OVERVIEW_LIST_ERROR"

export const UPDATE_KIND = 'UPDATE_KIND'

export const RESET_LIST = 'RESET_LIST'

export const fetchOverview = id => {
  return dispatch => {
    dispatch({
      type: FETCHING_OVERVIEW,
      value: true
    });

    return API.overview
      .getOverview(id)
      .then(response => {
        dispatch({
          type: FETCH_OVERVIEW,
          area_kinds: (response.data || {}).area_kinds,
          total_records: (response.data || {}).total_records
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_OVERVIEW_ERROR
        });
      });
  };
}

export const toggleProductsTable = (value) => {
  return dispatch => {
    return new Promise((resolve) => {
      dispatch({
        type: TOGGLE_PRODUCTS_TABLE,
        value
      });
      resolve(true)
    })
  }
}


export const fetchOverviewList = (id, kind_id) => {
  return dispatch => {
    dispatch({
      type: FETCHING_OVERVIEW_LIST,
      value: true
    });

    return API.overview
      .getOverviewList(id, kind_id)
      .then(response => {
        dispatch({
          type: FETCH_OVERVIEW_LIST,
          products: (response.data || {}).products
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_OVERVIEW_LIST_ERROR
        })
      })
  }
}

export const updateKind = kindId => {
  return dispatch => {
    dispatch({
      type: UPDATE_KIND,
      value: kindId
    });
  }
}

export const resetList = () => {
  return dispatch => {
    dispatch({
      type: RESET_LIST
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/overview.js